module.exports = __webpack_public_path__ + "img/morentx.f24a1f85.jpg";